import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

export default (app) => {
    app.use(ElementPlus); // 设置 z-index
};